import styled, { BorderRadius, Color, Spacing, Font } from '@nfinite/react-hubstairs/styled'
import { transparentize } from 'polished'

import IconComponent from 'components/Commons/Icon'
import ImageComponent from 'components/Commons/Image'

const SELECTED_IMAGE_PILL_WIDTH = 170

export const Icon = styled(IconComponent)`
  height: 100%;

  & svg {
    fill: ${Color.get('gray', 'dark')};
  }
`

export const LeftPanelContainer = styled('div')`
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
`

export const Image = styled(ImageComponent)`
  height: ${({ pictureSize }) => pictureSize}px;
`

export const ImageLabel = styled('div')`
  ${Spacing.generateMargin({ left: 'xs' })}
  ${Font.generate({ size: 's' })}
  color: ${Color.get('text')};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const PreviewWrapper = styled('div')`
  background-color: white;
  width: ${SELECTED_IMAGE_PILL_WIDTH}px;
  border: 1px solid ${({ imageActive }) => (imageActive ? Color.get('primary') : Color.get('gray'))};
  ${BorderRadius.generate({ all: 'm' })}
  ${Spacing.generatePadding({ all: 'xxs' })}
  display: flex;
  align-items: center;
  ${Spacing.generateMargin({ left: 'xs' })}
  cursor: pointer;
`

export const Separator = styled('div')`
  background-color: ${Color.get('gray', 'second')};
  width: 1px;
  height: 20px;
  padding: 1px;
  ${Spacing.generateMargin({ left: 'l', right: 's' })};
`

export const RightPanelContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const Clear = styled(IconComponent)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    max-width: 20px;
    max-height: 20px;
    fill: ${Color.get('text')};
  }
`

export const Container = styled('div')`
  width: 100%;
`

export const DropActiveContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ dragBoxHeight }) => dragBoxHeight}px;
  border: 1px dashed ${Color.get('primary')};
  background-color: ${Color.get('primary', 'light')};
  background-color: ${({ theme }) => transparentize(0.8, theme.getColor('primary'))};
  ${BorderRadius.generate({ all: 'm' })}
  color: ${Color.get('gray', 'dark')};
`
